import React from 'react';

export type ExperimentT = {
  [key: string]: number | boolean;
};

export type ExperimentContextT = {
  experiments: ExperimentT;
  setExperiments: (experiment: ExperimentT) => void;
};

const ExperimentContext = React.createContext<ExperimentContextT>({
  experiments: {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setExperiments: (experiment: ExperimentT) => {},
});

ExperimentContext.displayName = 'ExperimentContext';

export default ExperimentContext;
